import { useSectorDepotMetadata } from '@/api/useMetadata/useMasterMetadata'
import { invalidateTypedQueries, useApiClient } from '@/hooks/useApiClient'
import { FlagOutlined } from '@ant-design/icons'
import { GraviButton, Texto } from '@gravitate-js/excalibrr'
import { useQueryClient } from '@tanstack/react-query'
import { Dropdown, Spin, Tooltip, message } from 'antd'
import { useMemo } from 'react'
import { useSchedulePageFilters } from '../../Context/Filters/SchedulePageFilterContext'

export function AddCarrierDrivers() {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()
  const { setFilters } = useSchedulePageFilters()
  const { mutateAsync, isPending } = apiClient.useMutation('post', '/driver/carrier_depot/add_resource', {
    onError: (err) => message.error(typeof err?.detail === 'string' ? err.detail : 'An unknown error has occurred'),
    onSettled: () => invalidateTypedQueries(queryClient, 'post', '/driver/info/overview'),
    onSuccess: (_, { params }) => setFilters((prev) => ({ ...prev, nameFilter: params.query.depot })),
  })
  const { data } = useSectorDepotMetadata()
  const carrierDepots = useMemo(() => data?.depots?.filter((x) => !!x.carrier_id).map((x) => x.name) ?? [], [data])
  return (
    <Tooltip title='Add Carrier Driver'>
      <Dropdown
        trigger={['click']}
        menu={{
          items: carrierDepots.map((x) => ({
            icon: <FlagOutlined />,
            key: x,
            label: (
              <Texto category='label' className='carrier-color'>
                {x}
              </Texto>
            ),
            onClick: () => mutateAsync({ params: { query: { depot: x } } }),
          })),
        }}
      >
        <GraviButton
          size='small'
          icon={isPending ? <Spin size='small' className='carrier-color' /> : <FlagOutlined />}
          className='carrier-color'
        />
      </Dropdown>
    </Tooltip>
  )
}
